












import {
  computed,
  defineNuxtComponent,
  PropType
} from '~/utils/nuxt3-migration'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { ciRefresh } from '~/icons/source/regular/refresh'
import { diffInDays, format, timeDistanceFromNow } from '~/utils/date'
import { LocaleCode } from '~/models/locale/types'
import { useI18n } from '~/compositions/i18n'
import { ClassifiedStateColor } from '~/models/classified/types'

export default defineNuxtComponent({
  components: { CBadge },
  props: {
    modified: {
      type: String,
      required: true
    },
    stateColor: {
      type: String as PropType<ClassifiedStateColor>,
      default: null
    }
  },
  setup(props) {
    const { t, locale } = useI18n()

    const modifiedDaysAgo = computed(() =>
      Math.abs(diffInDays(props.modified, new Date()))
    )

    const modifiedTimeDistanceFromNow = computed(() =>
      timeDistanceFromNow(props.modified, {
        locale: locale as LocaleCode,
        strict: modifiedDaysAgo.value > 0,
        unit: 'day',
        addPrefix: false
      })
    )

    const internalStateColor = computed<ClassifiedStateColor>(() => {
      if (props.stateColor) {
        return props.stateColor
      }

      if (modifiedDaysAgo.value > 180) {
        return 'red'
      }

      if (modifiedDaysAgo.value > 90) {
        return 'yellow'
      }

      return 'green'
    })

    const colorClasses = computed(() => {
      if (internalStateColor.value === 'red') {
        return {
          background: 'tw-bg-red-100',
          text: 'tw-text-red-800'
        }
      }

      if (internalStateColor.value === 'yellow') {
        return {
          background: 'tw-bg-amber-100',
          text: 'tw-text-amber-800'
        }
      }

      return {
        background: 'tw-bg-blue-100',
        text: 'tw-text-blue-600'
      }
    })

    const tooltipText = computed(() => {
      const modifiedStatePrefix =
        internalStateColor.value === 'red'
          ? `${t('classified_modified_borderline')}. `
          : internalStateColor.value === 'yellow'
          ? `${t('classified_modified_not_touched')}. `
          : ''

      return `${modifiedStatePrefix}${t('last update')}: ${format(
        props.modified,
        'dd/MM/yyyy HH:mm',
        {
          locale: locale as LocaleCode
        }
      )}`
    })

    return {
      ciRefresh,
      colorClasses,
      tooltipText,
      modifiedTimeDistanceFromNow
    }
  }
})
